import RandingStyle4 from "../../randing/RandingStyle4";

function Randing085({ urlCode, urlCodeSettingId, apiUrl }) {
  return (
    <RandingStyle4
      urlCode={urlCode}
      urlCodeSettingId={urlCodeSettingId}
      img1Path={`${process.env.REACT_APP_CDN_BASE}/images/085/20250203_1.png`}
      img2Path={`${process.env.REACT_APP_CDN_BASE}/images/085/20250203_2.gif`}
      img3Path={`${process.env.REACT_APP_CDN_BASE}/images/085/20250203_3.jpg`}
      benefitInfoPosition="top"
      postBTN={`${process.env.REACT_APP_CDN_BASE}/images/003/01_241101_05.png`}
      companyName="본원"
      // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
      apiUrl={apiUrl}
    />
  );
}

export default Randing085;
